import { useEffect } from "react";
import Marquee from "react-fast-marquee";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const earlyAdopters = [
  { name: "Centro Nutrición Integral", initials: "CNI" },
  { name: "FitMed Clínica", initials: "FM" },
  { name: "Wellness Pro", initials: "WP" },
  { name: "NutriSport Elite", initials: "NSE" },
  { name: "Balance Vital", initials: "BV" },
  { name: "Health Coach Academy", initials: "HCA" },
  { name: "Nutrición Deportiva MX", initials: "NDM" },
  { name: "Vida Saludable", initials: "VS" },
];

export const EarlyAdoptersSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="py-16 overflow-hidden">
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <p className="text-zinc-600 text-sm tracking-wider uppercase">
          Confían en nosotros profesionales de
        </p>
      </motion.div>

      <Marquee
        gradient
        gradientColor="#050505"
        gradientWidth={100}
        speed={30}
        pauseOnHover
      >
        {earlyAdopters.map((adopter, index) => (
          <div
            key={index}
            className="mx-8 flex items-center gap-3 py-4"
          >
            <div className="w-10 h-10 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center">
              <span className="text-xs font-semibold text-zinc-500">
                {adopter.initials}
              </span>
            </div>
            <span className="text-zinc-500 text-sm whitespace-nowrap">
              {adopter.name}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
